import { GET_REGIONS_SUCCESS, SET_REGION } from './types'

import { AnyAction } from 'redux'

export interface IRegionReducerState {
  selectedRegion: string
  allowedRegions: string[]
}

const defaultState: IRegionReducerState = {
  selectedRegion: '',
  allowedRegions: []
}

function reducer(state = defaultState, { payload, type }: AnyAction) {
  switch (type) {
    case GET_REGIONS_SUCCESS:
      return {
        allowedRegions: payload.data.Data,
        selectedRegion: state.selectedRegion || payload.data.Data[0]
      }
    case SET_REGION:
      return {
        ...state,
        selectedRegion: payload.region
      }
    default:
      return state
  }
}

export default reducer
